import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import NavigationList from './NavigationList'
import LanguageSwitcher from './LanguageSwitcher'
import UserProfile from './UserProfile'

export default function MobileSidebar({ sidebarOpen, setSidebarOpen }) {
	const { t } = useTranslation()
	return (
		<Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
			<DialogBackdrop
				transition
				className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"
			/>

			<div className="fixed inset-0 flex">
				<DialogPanel
					transition
					className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full">
					<TransitionChild>
						<div className="absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0">
							<button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
								<span className="sr-only">{t('sidebar.actions.closeSidebar')}</span>
								<XMarkIcon aria-hidden="true" className="size-6 text-white" />
							</button>
						</div>
					</TransitionChild>

					<div className="flex grow flex-col gap-y-5 overflow-y-auto bg-indigo-800 px-6 pb-2 ring-1 ring-white/10">
						<div className="flex h-16 shrink-0 items-center">
							<img alt="CDP CRM" src="/infinity.svg" className="h-5 w-auto filter brightness-0 invert" />
							<p className="text-xs font-medium text-indigo-100 pl-2 pt-1">CDP CRM</p>
						</div>
						<nav className="flex flex-1 flex-col">
							<NavigationList sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
							<LanguageSwitcher />
						</nav>
						<UserProfile />
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	)
}
